import { FormState, useForm, useFormApi, useFormState } from "informedv4";
import * as React from "react";
import { nameof } from "ts-simple-nameof";
import { Site, Subject, DeviceType } from "webportalclient";
import { DeviceTypes } from "../../misc/api/apiTypes";
import { MultiSelect } from "../../forms/informedv4/MultiSelectV4";
import { Required } from "../../forms/validation/Required";
import { Package } from "@vitalograph/update-client";

export interface DevicesFormModel {
    deviceType: DeviceType;
    serialNumber: any;
    allocatedSite: Site;
    allocatedSubject: Subject;
    spirotracPackageVersion: Package
}

export interface DeviceFormProps {
    editMode: boolean;
    clientDevices: any[];
    sites: Site[];
    subjects: Subject[];
    deviceTypes: DeviceType[];
    spirotracPackages: Package[]
}

export interface FormattedPackage extends Package {
    displayValue: string
}
export const DeviceForm = ({ editMode, clientDevices, sites, subjects, deviceTypes, spirotracPackages }: DeviceFormProps) => {
    const formApi = useFormApi();
    const formState = useFormState();
    const packageOptions = spirotracPackages.map(p=>{
        const formatted = p as FormattedPackage;
        formatted.displayValue = p.name + "." + p.version;
        return formatted;
    })
    return (
        <div className="row">
            <div className="col-md-12">
                <div id="devicesFormPanel" className="panel panel-primary">
                    <div className="panel-body">
                        <div className="row">
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="SerialNumber">Serial Number</label>
                                <MultiSelect
                                    name={nameof<DevicesFormModel>(f => f.serialNumber)}
                                    disabled={!clientDevices.length || editMode}
                                    id="SerialNumber"
                                    field={nameof<DevicesFormModel>(f => f.serialNumber)}
                                    options={clientDevices}
                                    validate={Required}
                                    labelKey="serial"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="DeviceType">Device Type</label>
                                <MultiSelect
                                    name={nameof<DevicesFormModel>(f => f.deviceType)}
                                    disabled={!deviceTypes.length}
                                    id="DeviceType"
                                    field={nameof<DevicesFormModel>(f => f.deviceType)}
                                    validate={Required}
                                    options={deviceTypes}
                                    labelKey="name"
                                    valueKey="id"
                                    multi={false}
                                    onChange={() => {
                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSite)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSite), null)

                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSubject)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSubject), null)
                                    }}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSite">Allocated Site</label>
                                    <MultiSelect
                                    name={nameof<DevicesFormModel>(f => f.allocatedSite)}
                                    disabled={!sites.length || !formState.values.deviceType || (formState.values as Partial<DevicesFormModel>).deviceType?.id !== DeviceTypes.Spirotrac6}
                                        id="AllocatedSite"
                                        field={nameof<DevicesFormModel>(f => f.allocatedSite)}
                                        options={sites}
                                        labelKey="number"
                                        valueKey="id"
                                        multi={false}
                                    />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSubject">Allocated Subject</label>
                                <MultiSelect
                                    name={nameof<DevicesFormModel>(f => f.allocatedSubject)}
                                    disabled={!subjects.length || !formState.values.deviceType || (formState.values.deviceType as any)?.id === DeviceTypes.Spirotrac6}
                                    id="AllocatedSubject"
                                    field={nameof<DevicesFormModel>(f => f.allocatedSubject)}
                                    options={subjects}
                                    labelKey="number"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="spirotracPackageVersion">Package Version</label>
                                <MultiSelect
                                    name={nameof<DevicesFormModel>(f => f.spirotracPackageVersion)}
                                    disabled={!spirotracPackages.length || !formState.values.deviceType || (formState.values.deviceType as any)?.id != DeviceTypes.Spirotrac6}
                                    id="spirotracPackageVersion"
                                    field={nameof<DevicesFormModel>(f => f.spirotracPackageVersion)}
                                    options={packageOptions}
                                    labelKey="displayValue"
                                    valueKey="version"
                                    multi={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
